import { Box, CircularProgress, Container, makeStyles, Paper, Theme } from "@material-ui/core";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useCheckPermissionQuery, useIsLoggedInQuery } from "../../graphql/generated/graphql";
import PermissionKeys from "../../shared/PermissionKeys";
import PartnerPortal from "../PartnerPortal";
import Warehouse from "../Warehouse";

const useStyles = makeStyles((theme: Theme) => ({
  progress: {
    padding: theme.spacing(4),
    marginLeft: "auto",
    marginRight: "auto",
    width: 40 + 2 * theme.spacing(4),
    height: 40 + 2 * theme.spacing(4),
  },
}));

export default function Component()
{
  const { t } = useTranslation();
  const classes = useStyles();
  const { data: isLoggedInData } = useIsLoggedInQuery();

  const { data: checkWarehouseModulePermissionData, loading } = useCheckPermissionQuery({
    skip: !isLoggedInData?.isLoggedIn,
    variables: { PermissionKey: PermissionKeys.Warehouse.PWAModule }
  });

  if(loading) return <Box className={classes.progress}><CircularProgress color="secondary" /></Box>;

  if(checkWarehouseModulePermissionData?.CheckPermission)
  {
    return (
      <Container maxWidth="xs">
        <Warehouse />
      </Container>
    );
  }

  if(isLoggedInData?.isLoggedIn) return <PartnerPortal />

  return (
    <Paper elevation={3} style={{ padding: 20, margin: 20 }}>
      <h1>{t('home.title')}</h1>
      <p>{t('home.description')}</p>
    </Paper>
  );
}
